import { Clock, Route, Plane, Car } from "lucide-react";
import { useTranslation } from "react-i18next";

const QuickInfo = () => {
  const { t } = useTranslation();

  return (
    <section id="quick-info" className="py-20 bg-card">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <p className="font-body text-sm tracking-[0.3em] uppercase text-primary mb-4">
            {t("quickInfo.label")}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t("quickInfo.titlePrefix")} <span className="text-gradient-gold">{t("quickInfo.titleHighlight")}</span> ?
          </h2>
          <p className="font-body text-muted-foreground max-w-2xl mx-auto">
            {t("quickInfo.description")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          <div className="bg-background border border-border rounded-xl p-6 text-center">
            <Route className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="font-heading text-2xl font-bold text-foreground">175 km</p>
            <p className="font-body text-xs text-muted-foreground mt-1">{t("quickInfo.distance")}</p>
          </div>
          <div className="bg-background border border-border rounded-xl p-6 text-center">
            <Clock className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="font-heading text-2xl font-bold text-foreground">2h45</p>
            <p className="font-body text-xs text-muted-foreground mt-1">{t("quickInfo.duration")}</p>
          </div>
          <div className="bg-background border border-border rounded-xl p-6 text-center">
            <Car className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="font-heading text-2xl font-bold text-foreground">24/7</p>
            <p className="font-body text-xs text-muted-foreground mt-1">{t("quickInfo.availability")}</p>
          </div>
          <div className="bg-background border border-border rounded-xl p-6 text-center">
            <Plane className="w-8 h-8 text-primary mx-auto mb-3" />
            <p className="font-heading text-2xl font-bold text-foreground">{t("quickInfo.direct")}</p>
             <p className="font-body text-xs text-muted-foreground mt-1">{t("quickInfo.airport")}</p>
          </div>
        </div>

        <div className="mt-10 max-w-3xl mx-auto bg-background border border-border rounded-xl p-6">
          <h3 className="font-heading text-xl font-semibold text-foreground mb-3">
            {t("quickInfo.customTitle")}
          </h3>
          <p className="font-body text-sm text-muted-foreground leading-relaxed">
            {t("quickInfo.customDescription")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default QuickInfo;